package com.shadowings.gero.data.lessons.chapter14

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.Option
import com.shadowings.gero.domain.model.SingleSelectionContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import kotlin.random.Random
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_mi_ti_srw_1
import gero.composeapp.generated.resources.exp_content_mi_ti_srw_10
import gero.composeapp.generated.resources.exp_content_mi_ti_srw_11
import gero.composeapp.generated.resources.exp_content_mi_ti_srw_12
import gero.composeapp.generated.resources.exp_content_mi_ti_srw_13
import gero.composeapp.generated.resources.exp_content_mi_ti_srw_14
import gero.composeapp.generated.resources.exp_content_mi_ti_srw_2
import gero.composeapp.generated.resources.exp_content_mi_ti_srw_3
import gero.composeapp.generated.resources.exp_content_mi_ti_srw_4
import gero.composeapp.generated.resources.exp_content_mi_ti_srw_5
import gero.composeapp.generated.resources.exp_content_mi_ti_srw_6
import gero.composeapp.generated.resources.exp_content_mi_ti_srw_7
import gero.composeapp.generated.resources.exp_content_mi_ti_srw_8
import gero.composeapp.generated.resources.exp_content_mi_ti_srw_9
import gero.composeapp.generated.resources.exp_title_mi_ti_srw
import gero.composeapp.generated.resources.quiz_mi_ti_srw_1
import gero.composeapp.generated.resources.quiz_mi_ti_srw_1_opt1
import gero.composeapp.generated.resources.quiz_mi_ti_srw_1_opt2
import gero.composeapp.generated.resources.quiz_mi_ti_srw_1_opt3
import gero.composeapp.generated.resources.quiz_mi_ti_srw_1_opt4
import gero.composeapp.generated.resources.quiz_mi_ti_srw_2
import gero.composeapp.generated.resources.quiz_mi_ti_srw_2_opt1
import gero.composeapp.generated.resources.quiz_mi_ti_srw_2_opt2
import gero.composeapp.generated.resources.quiz_mi_ti_srw_2_opt3
import gero.composeapp.generated.resources.quiz_mi_ti_srw_2_opt4

fun getMiTiSrwContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_mi_ti_srw,
            content = Res.string.exp_content_mi_ti_srw_1,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "W19-X1:M17-O34:D21-G43", rtl = false, cart = false, size = 56.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_mi_ti_srw,
            content = Res.string.exp_content_mi_ti_srw_2,
            face = Faces.Surprised,
            character = Characters.Nilo,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "O34:D21-G43", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_mi_ti_srw,
            content = Res.string.exp_content_mi_ti_srw_3,
            face = Faces.Happy,
            character = Characters.Nilo,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "O34:D21-G43", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_mi_ti_srw,
            content = Res.string.exp_content_mi_ti_srw_4,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_mi_ti_srw,
            content = Res.string.exp_content_mi_ti_srw_5,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "W19-X1:Z4", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_mi_ti_srw,
            content = Res.string.exp_content_mi_ti_srw_6,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "W19", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_mi_ti_srw,
            content = Res.string.exp_content_mi_ti_srw_7,
            face = Faces.Doubt,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_mi_ti_srw,
            content = Res.string.exp_content_mi_ti_srw_8,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_mi_ti_srw,
            content = Res.string.exp_content_mi_ti_srw_9,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_mi_ti_srw,
            content = Res.string.exp_content_mi_ti_srw_10,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_mi_ti_srw,
            content = Res.string.exp_content_mi_ti_srw_11,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_mi_ti_srw,
            content = Res.string.exp_content_mi_ti_srw_12,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_mi_ti_srw,
            content = Res.string.exp_content_mi_ti_srw_13,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_mi_ti_srw,
            content = Res.string.exp_content_mi_ti_srw_14,
            face = Faces.Surprised,
            character = Characters.Nilo,
        ),
    )
}

fun getMiTiSrwQuizContent(
    hiero: List<Hiero> = emptyList(),
    words: List<Word> = emptyList(),
    verbs: List<Verb> = emptyList(),
    languageCode: String = "",
    verbSentences: List<SentenceOptions> = emptyList(),
    random: Random = Random
): List<IQuizContent> {
    val specificQuizzes: List<IQuizContent> = listOf(
        SingleSelectionContent(
            text = Res.string.quiz_mi_ti_srw_1,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_mi_ti_srw_1_opt1, correct = true),
                Option(Res.string.quiz_mi_ti_srw_1_opt2, correct = false),
                Option(Res.string.quiz_mi_ti_srw_1_opt3, correct = false),
                Option(Res.string.quiz_mi_ti_srw_1_opt4, correct = false)
            ).shuffled(random)
        ),
        SingleSelectionContent(
            text = Res.string.quiz_mi_ti_srw_2,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_mi_ti_srw_2_opt1, correct = true),
                Option(Res.string.quiz_mi_ti_srw_2_opt2, correct = false),
                Option(Res.string.quiz_mi_ti_srw_2_opt3, correct = false),
                Option(Res.string.quiz_mi_ti_srw_2_opt4, correct = false)
            ).shuffled(random)
        )
    )

    val fillerQuizzes = getLaParticellaNiQuizContent(
        hiero = hiero,
        words = words,
        verbs = verbs,
        languageCode = languageCode,
        verbSentences = verbSentences,
        random = random
    ).take(8)

    return specificQuizzes + fillerQuizzes
}
